/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EFormePersonne } from './EFormePersonne';
import {
    EFormePersonneFromJSON,
    EFormePersonneFromJSONTyped,
    EFormePersonneToJSON,
} from './EFormePersonne';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';

/**
 * 
 * @export
 * @interface EListSearchTypeEFormePersonneCombinableCriteria
 */
export interface EListSearchTypeEFormePersonneCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeEFormePersonneCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EFormePersonne}
     * @memberof EListSearchTypeEFormePersonneCombinableCriteria
     */
    value?: EFormePersonne;
    /**
     * 
     * @type {EFormePersonne}
     * @memberof EListSearchTypeEFormePersonneCombinableCriteria
     */
    secondaryValue?: EFormePersonne;
}

/**
 * Check if a given object implements the EListSearchTypeEFormePersonneCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeEFormePersonneCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeEFormePersonneCombinableCriteriaFromJSON(json: any): EListSearchTypeEFormePersonneCombinableCriteria {
    return EListSearchTypeEFormePersonneCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeEFormePersonneCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeEFormePersonneCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EFormePersonneFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EFormePersonneFromJSON(json['secondaryValue']),
    };
}

export function EListSearchTypeEFormePersonneCombinableCriteriaToJSON(value?: EListSearchTypeEFormePersonneCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EFormePersonneToJSON(value.value),
        'secondaryValue': EFormePersonneToJSON(value.secondaryValue),
    };
}

